<template>
  <div class="col-12 pl-2 mb-4">
    <b-card
      mt-2
      pt-4
    >
      <b-card-text>
        <b-button
          v-if="editMode"
          class="float-right"
          variant="danger"
          @click="deleteContractresponsiblity"
        >
          <i class="fas fa-times" />
        </b-button>

        <v-flex sm12>
          <b-row>
            <h4 :class="editMode ? 'pt-3' : 'pt-3 pl-3'">
              <span v-if="contractResponsible.id === 0">Neuer </span>
              Verantwortlicher

              <span v-if="currentContact && currentContact.lastName">
                - {{ currentContact.lastName }}</span>

              <span v-if="currentContact && currentContact.firstName">
                {{ currentContact.firstName }}</span>
            </h4>
          </b-row>
        </v-flex>

        <b-row style="opacity: 0">
          --- Not Visible Row
        </b-row>

        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />

        <u-loader v-if="isLoading" />

        <span v-else>
          <!--  Typ/ Vorname-->
          <b-row class="mt-2">
            <!-- Typ -->
            <label class="mt-4 col-2 defaultLabel"> Typ </label>
            <div class="col-4 pl-1">
              <v-combobox
                v-model="contractResponsible.typeList"
                :disabled="!editMode"
                :items="typeTags"
                chips
                clearable
                deletable-chips
                multiple
              />
            </div>
            <!-- Vorname-->
            <label class="mt-4 pr-0 col-2 defaultLabel"> Vorname </label>
            <div class="col-4 pl-0">
              <v-text-field
                v-model="currentContact.firstName"
                disabled
                label="Vorname"
              />
            </div>
          </b-row>

          <!-- Hauptverantw./ Nachname-->
          <b-row class="mt-2">
            <!-- Hauptverantw. -->
            <label class="mt-4 col-2 defaultLabel"> Hauptverantw. </label>
            <div class="col-4 pl-1">
              <label class="mt-4">
                <input
                  v-model="contractResponsible.mainResponsible"
                  :disabled="!editMode"
                  name="check"
                  type="checkbox"
                >
                <span class="label-text" />
              </label>
            </div>
            <!-- Nachname-->
            <label class="mt-4 pr-0 col-2 defaultLabel"> Nachname </label>
            <div class="col-4 pl-0">
              <v-text-field
                v-model="currentContact.lastName"
                disabled
                label="Nachname"
              />
            </div>
          </b-row>

          <!-- Gav-Verantwortlich/ Auskunft -->
          <b-row class="mt-2">
            <label class="mt-4 col-2 defaultLabel"> GAV-Verantwortlich </label>
            <div class="col-4 pl-1">
              <label class="mt-4">
                <input
                  v-model="contractResponsible.gavResponsible"
                  :disabled="!editMode"
                  name="check"
                  type="checkbox"
                >
                <span class="label-text" />
              </label>
            </div>
            <!-- Auskunft -->
            <label class="mt-4 col-2 defaultLabel"> Auskunft </label>
            <div class="col-4 pl-1">
              <v-autocomplete
                v-model="selectedAuskunft"
                :disabled="!editMode"
                :items="AuskunftOptions"
                :loading="isloadingOrganisationsSearch"
                :placeholder="editMode ? 'Als Auskunft verwenden' : ''"
                :filter="filter"
                clearable
                multiple
                item-text="text"
                item-value="value"
                @input="setAuskunft"
              />
            </div>
          </b-row>

          <!-- Organisation / Telefon-->
          <b-row class="mt-2">
            <!-- Organisation. -->
            <label class="mt-4 col-2 defaultLabel"> Organisation </label>
            <div class="col-4 pl-1">
              <v-autocomplete
                v-model="contractResponsible.organisationId"
                :disabled="!editMode"
                :items="oragnisations"
                :loading="isloadingOrganisationsSearch"
                :placeholder="editMode ? 'Nach Organisation suchen ...' : ''"
                :filter="filter"
                clearable
                item-text="name"
                item-value="id"
                no-data-text="Es wurden keine Einträge gefunden"
                @input="setOrganisations('')"
                @input.native="searchOrganisations($event.srcElement.value)"
              />
            </div>
            <!-- Telefon-->
            <label class="mt-4 pr-0 col-2 defaultLabel"> Telefon </label>
            <div class="col-4 pl-0">
              <v-text-field
                v-model="currentContact.phone"
                disabled
                label="Telefon"
              />
            </div>
          </b-row>

          <!-- Kontakt / Email-->
          <b-row class="mt-2">
            <!-- Kontakt. -->
            <label class="mt-4 col-2 defaultLabel"> Kontakt </label>
            <div
              class="col-4 pl-1"
              :style="contactBackgroundStyle"
            >
              <v-autocomplete
                v-model="contractResponsible.contactId"
                :disabled="!editMode"
                :items="contacts"
                :loading="isloadingContactsSearch"
                :no-data-text="emptyContactsMsg"
                :filter="filter"
                clearable
                item-text="lastName"
                item-value="id"
                placeholder="Nach Kontakt suchen ..."
                @input="setContacts()"
                @input.native="searchContacts($event.srcElement.value)"
              />
            </div>
            <!-- Email-->
            <label class="mt-4 pr-0 col-2 defaultLabel"> Email </label>
            <div class="col-4 pl-0">
              <v-text-field
                v-model="currentContact.email"
                disabled
                label="Email"
              />
            </div>
          </b-row>

          <b-row
            v-if="
              !contractResponsible.contactId &&
                !contractResponsible.organisationId &&
                editMode
            "
            class="mt-5"
          >
            <div class="col-12">
              <v-alert
                :value="true"
                outline
                type="error"
              >
                Ein Kontakt oder eine Organisation muss ausgewählt werden.
              </v-alert>
            </div>
          </b-row>

          <b-row
            v-if="editMode"
            class="mt-5"
          >
            <div class="col-12">
              <b-button
                v-if="contractResponsible.id === 0"
                :disabled="
                  !contractResponsible.contactId &&
                    !contractResponsible.organisationId
                "
                variant="success"
                @click="createContractresponsiblity"
              >
                <i class="fas fa-plus mr-2" /> Erstellen
              </b-button>
              <span v-else>
                <b-button
                  :disabled="
                    !contractResponsible.contactId &&
                      !contractResponsible.organisationId
                  "
                  variant="success"
                  @click="updateContractresponsiblity"
                >
                  <i class="fas fa-save mr-2" /> Speichern
                </b-button>
                <b-button
                  class="ml-2"
                  variant="danger"
                  @click="cancaelContractresponsiblity"
                >
                  <i class="fas fa-ban mr-2" /> Abbrechen
                </b-button>
              </span>
            </div>
          </b-row>
        </span>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {
  GetContacts,
  GetContactsByOrganisation,
  GetContactsWithId,
  GetOragnisations,
  GetOrganisationWithId,
} from "@/services/user.crm.service";
import {
  CreateNewContractResponsiblity,
  DeleteContractResponsiblity,
  GetContractResponsiblityTags,
  SaveContractResponsiblity,
} from "@/services/contract.service";

export default {
  props: {
    contractResponsible: {
      type: Object,
      default: () => {},
    },
    contractId: {
      type: String,
      default: "0",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isLoading: false,
      oragnisations: [],
      contacts: [],
      currentContact: {
        lastName: "",
        firstName: "",
        email: "",
        phone: "",
        id: 0,
      },
      AuskunftOptions: [
        { text: "Kontakt Paritätische Organe", value: 1 },
        { text: "Kontakt Arbeitnehmervetretung", value: 2 },
        { text: "Kontakt Arbeitgebervertretung", value: 3 },
      ],
      selectedAuskunft: [],
      currentOrganisation: {},
      isloadingOrganisationsSearch: false,
      isloadingContactsSearch: false,
      errorObject: null,
      intialLoadingOrganisations: true,
      intialLoadingContacts: true,
      isSetOrganisations: false,
      isSetContacts: false,
      emptyContactsMsg: "Es wurden keine Einträge gefunden",
      typeTags: [],
      originalContractResponsible: null,
    };
  },

  computed: {
    selectedOrganisaiton() {
      //Needed when the organisation selection is cleared
      return this.contractResponsible.organisationId;
    },
    selectedContact() {
      //Needed when the contact selection is cleared
      return this.contractResponsible.contactId;
    },
    contactBackgroundStyle() {
      return {
        "background-color": this.contacts.find(
          (x) => x.id == this.contractResponsible.contactId,
        )?.inactive
          ? "rgba(255, 0, 0, 0.2)"
          : "",
      };
    },
  },

  watch: {
    intialLoadingOrganisations() {
      // Check if the Organisation is complety initial loaded
      if (!this.intialLoadingContacts) {
        // If the Contacts also has been loaded, we can render the componet
        // Prevents that the Componet is not completly loaded
        this.isLoading = false;
      }
    },
    intialLoadingContacts() {
      // Check if the Contacts is complety initial loaded
      if (!this.intialLoadingOrganisations) {
        // If the Organisations also has been loaded, we can render the componet
        // Prevents that the Componet is not completly loaded
        this.isLoading = false;
      }
    },
    currentContact() {
      // Check if the Current Contact has changed
      if (this.currentContact && this.currentContact.organisationId) {
        //Check if the current Contact has a Organisation, when it has a Organisation, we need to get the Organisation
        this.emptyContactsMsg =
          "Es wurden keine Einträge mit Ihrer Suche und der Organisation gefunden";
        this.contractResponsible.organisationId =
          this.currentContact.organisationId;
        this.getOrgantisationById(this.currentContact.organisationId);
      }
    },
    currentOrganisation() {
      // Check if the Current Organisation has changed
      this.getContactsByOrganisationId(this.currentOrganisation.id);
    },
    selectedOrganisaiton(value) {
      //Is executed, when a selection is made or the selction is deselected
      if (!value) {
        //When its organisation selection is deselcted

        //We nede to reload the organisations list, because the list will be empty
        this.searchOrganisations("");
        //reset the contacts select with a deafault search, when the contacts value is empty
        if (!this.contractResponsible.contactId) {
          this.searchContacts("");
        }
      }
    },
    selectedContact(value) {
      //Is executed, when a selection is made or the selction is deselected
      if (!value) {
        //When its contacts selection is deselcted

        //We need to reload the contacts list, because the list will be empty
        this.searchContacts("");
        //We need to reset the Current Contacts object, the current contacts object is holds the values of the contact information
        this.resetContacts();
      }
    },
  },

  created() {
    this.isLoading = true;
    this.originalContractResponsible = JSON.parse(
      JSON.stringify(this.contractResponsible),
    );
    if (this.contractResponsible.auskunftKontakParitaetischeOrgane) {
      this.selectedAuskunft.push(1);
    }
    if (this.contractResponsible.auskunftKontaktArbeitnehmervertretung) {
      this.selectedAuskunft.push(2);
    }
    if (this.contractResponsible.auskunftKontaktArbeitgebervertretung) {
      this.selectedAuskunft.push(3);
    }
    this.getTypeTags();
    this.getOrganisations();
    this.getContacts();
  },

  methods: {
    // Start - Funktionen zur Vertragsverantwortlichen/Contractresponsibles
    filter() {
      return true;
    },
    updateContractresponsiblity() {
      this.isLoading = true;
      SaveContractResponsiblity(
        this.contractId,
        this.contractResponsible,
        (response) => {
          if (response.data) {
            this.$parent.reloadContractResponse(this.index);
          }
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    deleteContractresponsiblity() {
      this.isLoading = true;
      if (this.contractResponsible.id) {
        DeleteContractResponsiblity(
          this.contractId,
          this.contractResponsible.id,
          () => {
            this.$parent.reloadContractResponse(this.index);
            this.isLoading = false;
          },
          (error) => {
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      } else {
        this.$parent.removeContractResponse(this.index);
      }
    },

    createContractresponsiblity() {
      this.isLoading = true;
      CreateNewContractResponsiblity(
        this.contractId,
        this.contractResponsible,
        (response) => {
          if (response.data) {
            this.$parent.reloadContractResponse(this.index);
          }
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    cancaelContractresponsiblity() {
      this.isLoading = true;
      this.intialLoadingContacts = true;
      this.intialLoadingOrganisations = true;
      this.contractResponsible.contactId =
        this.originalContractResponsible.contactId;
      this.contractResponsible.mainResponsible =
        this.originalContractResponsible.mainResponsible;
      this.contractResponsible.auskunftKontakParitaetischeOrgane =
        this.originalContractResponsible.auskunftKontakParitaetischeOrgane;
      this.contractResponsible.auskunftKontaktArbeitnehmervertretung =
        this.originalContractResponsible.auskunftKontaktArbeitnehmervertretung;
      this.contractResponsible.auskunftKontaktArbeitgebervertretung =
        this.originalContractResponsible.auskunftKontaktArbeitgebervertretung;
      this.contractResponsible.gavResponsible =
        this.originalContractResponsible.gavResponsible;
      this.contractResponsible.organisationId =
        this.originalContractResponsible.organisationId;
      this.contractResponsible.types = this.originalContractResponsible.types;
      this.contractResponsible.typeList =
        this.originalContractResponsible.typeList;
      this.getOrganisations();
      this.getContacts();
    },
    //// Start - Organisation Search
    getOrganisations() {
      // Get Organisations initial
      if (!this.contractResponsible.organisationId) {
        // Get the first 20 Organisations, when no Organisations has been set
        this.searchOrganisations("");
      } else {
        // Load the Organisation, that has been set
        this.getOrgantisationById(this.contractResponsible.organisationId);
      }
    },
    setAuskunft(value) {
      this.contractResponsible.auskunftKontakParitaetischeOrgane = false;
      this.contractResponsible.auskunftKontaktArbeitnehmervertretung = false;
      this.contractResponsible.auskunftKontaktArbeitgebervertretung = false;

      value.forEach((val) => {
        switch (val) {
          case 1:
            this.contractResponsible.auskunftKontakParitaetischeOrgane = true;
            break;
          case 2:
            this.contractResponsible.auskunftKontaktArbeitnehmervertretung = true;
            break;
          case 3:
            this.contractResponsible.auskunftKontaktArbeitgebervertretung = true;
            break;
          default:
            break;
        }
      });
    },
    setOrganisations(searchTerm) {
      // When the User confirms his Input,
      this.isSetOrganisations = true;
      this.searchOrganisations(searchTerm);
    },
    searchOrganisations(searchTerm) {
      // Search Organisations with a search term, by default only 10 entries
      this.isloadingOrganisationsSearch = true;
      GetOragnisations(
        10,
        1,
        searchTerm,
        "",
        0,
        (response) => {
          // Check if the Response has organisations, to prevent empty values
          if (response && response.organisations) {
            this.oragnisations = response.organisations;
          }

          // If the current contract responsible, has a organtisaion
          if (this.contractResponsible.organisationId) {
            // Get the current Organisation with the Id
            this.getOrgantisationById(this.contractResponsible.organisationId);
          } else {
            this.checkInitialLoadingOrganisations();
            this.isloadingOrganisationsSearch = false;
          }
        },
        (error) => {
          this.errorObject = error;
          this.checkInitialLoadingOrganisations();
          this.isloadingOrganisationsSearch = false;
        },
      );
    },
    getOrgantisationById(organisationId) {
      // Get the Organisation with Id
      this.isloadingOrganisationsSearch = true;
      GetOrganisationWithId(
        organisationId,
        (response) => {
          // Map Contents to Organisation itself
          response.name = response.organisationContents[0].name;
          // Is set Organisation is only true when the user confirm his input
          if (this.isSetOrganisations) {
            this.currentOrganisation = response;
            this.isSetOrganisations = false;
          }

          if (!this.oragnisations.length) {
            this.oragnisations.push(response);
            this.checkInitialLoadingOrganisations();
            this.isloadingOrganisationsSearch = false;
          } else {
            // Check if the Organisation exist in the List, or it will has render issues
            if (
              !this.oragnisations.some(
                (oragnisation) => oragnisation.id === response.id,
              )
            ) {
              // Organisation Found
              this.oragnisations.push(response);
              this.checkInitialLoadingOrganisations();
              this.isloadingOrganisationsSearch = false;
            } else {
              // Organisation not Found
              this.checkInitialLoadingOrganisations();
              this.isloadingOrganisationsSearch = false;
            }
          }
        },
        (error) => {
          this.checkInitialLoadingOrganisations();
          this.isloadingOrganisationsSearch = false;
          this.errorObject = error;
        },
      );
    },

    checkInitialLoadingOrganisations() {
      // Its used for Intial checking the Organisation when the Compontend is loaded
      if (this.intialLoadingOrganisations) {
        this.intialLoadingOrganisations = false;
      }
    },
    ////  End - Organisation Search

    //// Start - Contacts Search
    getContacts() {
      if (!this.contractResponsible.contactId) {
        this.searchContacts("");
      } else {
        this.isSetContacts = true;
        this.getContactsById(this.contractResponsible.contactId);
      }
    },
    setContacts(searchTerm) {
      this.isSetContacts = true;
      this.searchContacts(searchTerm);
    },
    searchContacts(searchTerm) {
      // Search only trough all Contacts, when no Organisation is set
      if (!this.contractResponsible.organisationId) {
        this.isloadingContactsSearch = true;

        //Change Contacts Message for better User experience
        this.emptyContactsMsg = "Es wurden keine Einträge gefunden";

        GetContacts(
          20,
          1,
          searchTerm,
          "",
          0,
          1,
          (response) => {
            if (response && response.contacts) {
              this.contacts = response.contacts;
            }
            // Check if the Contract has already a Contact
            if (this.contractResponsible.contactId) {
              //Get Current Contact, is neeed, beacuse the Call GetContacts, only gets the first 20 Results of the Serach
              //We need to load the current Contact to prevent, that the Currrent Contact is getting lost in the Contacts list
              this.getContactsById(this.contractResponsible.contactId);
            } else {
              //No Contact is setted
              this.resetContacts();
              this.checkInitialLoadingContacts();
              this.isloadingContactsSearch = false;
            }
          },
          (error) => {
            this.errorObject = error;
            this.checkInitialLoadingContacts();
            this.isloadingContactsSearch = false;
          },
        );
      } else {
        // Get the Current Contact, for the Contactdetails
        if (this.contractResponsible.contactId) {
          this.getContactsById(this.contractResponsible.contactId);
        } else {
          this.checkInitialLoadingContacts();
          this.isloadingContactsSearch = false;
        }
      }
    },

    getContactsById(contactId) {
      this.isloadingContactsSearch = true;

      GetContactsWithId(
        contactId,
        (response) => {
          if (this.isSetContacts) {
            //Prevent that the Contact is always changes, it should only change, if the User types enter or select the entry
            this.isSetContacts = false;
            this.currentContact = response;
          }

          // Check if the Contacts list already has Values
          if (!this.contacts.length) {
            // When the Contacts list is empty, we can assing the Value without cheking for duplicates
            this.contacts.push(response);
            this.checkInitialLoadingContacts();
            this.isloadingContactsSearch = false;
          } else {
            // Check if current Contact is already in the Contacts List, for preventing duplicates
            if (!this.contacts.some((contact) => contact.id === response.id)) {
              // No Duplicates Found
              this.contacts.push(response);
              this.checkInitialLoadingContacts();
              this.isloadingContactsSearch = false;
            } else {
              // Duplicate found
              this.checkInitialLoadingContacts();
              this.isloadingContactsSearch = false;
            }
          }
        },
        (error) => {
          this.errorObject = error;
          this.checkInitialLoadingContacts();
          this.isloadingContactsSearch = false;
        },
      );
    },
    getContactsByOrganisationId(organisationId) {
      // When we have a Organisation we load only the Contacts from the specific Organisation
      this.isloadingContactsSearch = true;
      GetContactsByOrganisation(
        organisationId,
        (response) => {
          this.contacts = response;

          if (response && response.length) {
            //Change Contacts Message for better User experience
            this.emptyContactsMsg =
              "Es wurden keine Einträge mit Ihrer Suche und der Organisation gefunden";

            if (
              !response.some((contact) => contact.id === this.currentContact.id)
            ) {
              this.resetContacts();
              this.isloadingContactsSearch = false;
            } else {
              this.isloadingContactsSearch = false;
            }
          } else {
            //Change Contacts Message for better User experience
            this.emptyContactsMsg =
              "Es wurden keine Einträge zu den Kontakten mit der Organisation ( " +
              this.currentOrganisation.name +
              " ) gefunden";

            this.resetContacts();
            this.isloadingContactsSearch = false;
          }
        },
        (error) => {
          this.errorObject = error;
          this.isloadingContactsSearch = false;
        },
      );
    },
    resetContacts() {
      this.contractResponsible.contactId = null;
      this.currentContact.lastName = "";
      this.currentContact.firstName = "";
      this.currentContact.email = "";
      this.currentContact.phone = "";
      this.currentContact.id = 0;
    },

    checkInitialLoadingContacts() {
      if (this.intialLoadingContacts) {
        this.intialLoadingContacts = false;
      }
    },

    ////  End - Contacts Search

    //// Start - Type Taging
    getTypeTags() {
      GetContractResponsiblityTags(
        (response) => {
          if (response.data) {
            if (response.data.length) {
              response.data.forEach((typeTag) => {
                this.typeTags.push(typeTag.typeName);
              });
            }
          }
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    //// End - Type Taging
    // Ende - Funktionen zur Vertragsverantwortlichen/Contractresponsibles
  },
};
</script>

<style scoped></style>
